/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonRelayerChannelDetailInfo } from '../models/BabylonRelayerChannelDetailInfo';
import type { BabylonRelayerChannelDetailRequest } from '../models/BabylonRelayerChannelDetailRequest';
import type { BabylonRelayerChannelListInfo } from '../models/BabylonRelayerChannelListInfo';
import type { BabylonRelayerChannelListRequest } from '../models/BabylonRelayerChannelListRequest';
import type { BabylonRelayerChannelOperatorListInfo } from '../models/BabylonRelayerChannelOperatorListInfo';
import type { BabylonRelayerChannelOperatorRequest } from '../models/BabylonRelayerChannelOperatorRequest';
import type { BabylonRelayerChannelTransactionListInfo } from '../models/BabylonRelayerChannelTransactionListInfo';
import type { BabylonRelayerChannelTransactionRequest } from '../models/BabylonRelayerChannelTransactionRequest';
import type { BabylonRelayerDetailInfo } from '../models/BabylonRelayerDetailInfo';
import type { BabylonRelayerDetailRequest } from '../models/BabylonRelayerDetailRequest';
import type { BabylonRelayerListInfo } from '../models/BabylonRelayerListInfo';
import type { BabylonRelayerListRequest } from '../models/BabylonRelayerListRequest';
import type { BabylonRelayerNetworkFlowInfo } from '../models/BabylonRelayerNetworkFlowInfo';
import type { BabylonRelayerTransferAssetListInfo } from '../models/BabylonRelayerTransferAssetListInfo';
import type { BabylonRelayerTransferAssetListRequest } from '../models/BabylonRelayerTransferAssetListRequest';
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RelayerControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerDetail({
        requestBody,
    }: {
        requestBody: BabylonRelayerDetailRequest,
    }): CancelablePromise<BabylonRelayerDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerTransferAssetList({
        requestBody,
    }: {
        requestBody: BabylonRelayerTransferAssetListRequest,
    }): CancelablePromise<BabylonRelayerTransferAssetListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/transfer/asset/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerNetworkFlow({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<BabylonRelayerNetworkFlowInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/network/flow',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerList({
        requestBody,
    }: {
        requestBody: BabylonRelayerListRequest,
    }): CancelablePromise<BabylonRelayerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerChannelDetail({
        requestBody,
    }: {
        requestBody: BabylonRelayerChannelDetailRequest,
    }): CancelablePromise<BabylonRelayerChannelDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/channel',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerChannelTransactionList({
        requestBody,
    }: {
        requestBody: BabylonRelayerChannelTransactionRequest,
    }): CancelablePromise<BabylonRelayerChannelTransactionListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/channel/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerChannelOperatorList({
        requestBody,
    }: {
        requestBody: BabylonRelayerChannelOperatorRequest,
    }): CancelablePromise<BabylonRelayerChannelOperatorListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/channel/operator/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getRelayerConnectionList({
        requestBody,
    }: {
        requestBody: BabylonRelayerChannelListRequest,
    }): CancelablePromise<BabylonRelayerChannelListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/relayer/channel/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
